<template>
  <div class="action-widget">
    <div class="position-relative">
      <transition name="slide">
        <div v-if="!collapsed" class="action-body">
          <b-row>
            <b-col cols="12">
              <b-button
                :to="{ name: 'scan' }"
                @click="collapsed = true"
                variant="ice"
              >
                <i class="fas fa-camera" />
              </b-button>
            </b-col>
          </b-row>
        </div>
      </transition>
      <div class="widget-collapse" @click="collapse">
        <i
          class="ifr"
          :class="{ 'if-chevron-down': collapsed, 'if-chevron-up': !collapsed }"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ActionWidget",
    beforeRouteUpdate: (from, to, next) => {
      this.collapsed = true;
      next();
    },
    data() {
      return {
        collapsed: true,
      };
    },
    methods: {
      collapse() {
        this.collapsed = !this.collapsed;
      },
    },
  };
</script>

<style lang="scss">
  @import "../styles/scss/_colors.scss";

  .action-widget {
    z-index: 10;
    width: 300px;
    position: fixed;
    top: 0px;
    right: 1rem;

    .action-body {
      height: 100px;
      padding: 1rem;
      background-color: $kombus-blue;
      border-bottom-left-radius: 10px;

      .btn {
        height: 70px;
        font-size: 40px;
      }
    }

    .widget-collapse {
      text-align: center;
      background-color: $kombus-blue;
      position: absolute;
      right: 0px;
      bottom: -20px;
      width: 40px;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  }
</style>
